/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		"template.addresses": 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["shopifySlateJsonp"] = window["shopifySlateJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push(["./scripts/templates/customers/addresses.js","vendors@template.account@template.addresses"]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ "./scripts/templates/customers/addresses.js":
/*!**************************************************!*\
  !*** ./scripts/templates/customers/addresses.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
eval("\n\nvar _themeAddresses = __webpack_require__(/*! @shopify/theme-addresses */ \"../node_modules/@shopify/theme-addresses/theme-addresses.js\");\n\n/**\n * Customer Addresses Script\n * ------------------------------------------------------------------------------\n * A file that contains scripts highly couple code to the Customer Addresses\n * template.\n *\n * @namespace customerAddresses\n */\nvar selectors = {\n  addressContainer: '[data-address]',\n  addressFields: '[data-address-fields]',\n  addressToggle: '[data-address-toggle]',\n  addressForm: '[data-address-form]',\n  addressDeleteForm: '[data-address-delete-form]'\n};\nvar hideClass = 'hide';\n\nfunction initializeAddressForm(container) {\n  var addressFields = container.querySelector(selectors.addressFields);\n  var addressForm = container.querySelector(selectors.addressForm);\n  var deleteForm = container.querySelector(selectors.addressDeleteForm);\n  container.querySelectorAll(selectors.addressToggle).forEach(function (button) {\n    button.addEventListener('click', function () {\n      addressForm.classList.toggle(hideClass);\n    });\n  });\n  (0, _themeAddresses.AddressForm)(addressFields, 'en', {\n    shippingCountriesOnly: true\n  });\n\n  if (deleteForm) {\n    deleteForm.addEventListener('submit', function (event) {\n      var confirmMessage = deleteForm.getAttribute('data-confirm-message');\n\n      if (!window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {\n        event.preventDefault();\n      }\n    });\n  }\n}\n\nvar addressForms = document.querySelectorAll(selectors.addressContainer);\n\nif (addressForms.length) {\n  addressForms.forEach(function (addressContainer) {\n    initializeAddressForm(addressContainer);\n  });\n}\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./scripts/templates/customers/addresses.js\n");

/***/ })

/******/ });